import { Card, MultipleChart, MultipleChartData } from "components";
import { CardSection } from "../CardSection";
import { GraphValueType } from "../../types";
import { convertNumber } from "utils";
import moment from "moment"
import { useState } from "react";
import { useExpenseIncome, useProfitAndLose } from "../../utils";


export function ProfitAndLost(params: {
    listIncome?: GraphValueType[],
    list2?: GraphValueType,
    listExpense?: GraphValueType[],
    start_date?: string | undefined,
    end_date?: string | undefined,
    month?: string | undefined,
    year?: string | undefined,
    location_id?: string
}) {

    const { data: valueProfitAndLose } = useProfitAndLose({
        date: `${params.year}-${params.month}-01`,
        location_id: params.location_id ? params.location_id : ""
    })

    const { data: valueIncome } = useExpenseIncome({
        date: `${params.year}-${params.month}-01`,
        location_id: params.location_id ? params.location_id : "",
        type: "income"
    })

    const { data: valueExpense } = useExpenseIncome({
        date: `${params.year}-${params.month}-01`,
        location_id: params.location_id ? params.location_id : "",
        type: "expenses"
    })

    const sumValueIncome = valueIncome ? valueIncome.reduce((a, b) => a + b.balance, 0) : 0;
    const sumValueExpense = valueExpense ? valueExpense.reduce((a, b) => a + b.balance, 0) : 0;

    const [chartType, setChartType] = useState<"line" | "bar">("line")

    const dataChartIncome: MultipleChartData = {
        labels: ["", ...valueIncome?.map((item) => item.location_name) || []],
        datasets: [
            {
                data: [0, ...valueIncome?.map((item) => item.balance) || []],
                backgroundColor: chartType === "line" ? ["rgba(255, 165, 0, 0.2)"] : ['rgb(167, 230, 255)'],
                borderColor: chartType === "line" ? ["rgb(255, 165, 0)"] : ['rgb(167, 230, 255)'],
                fill: "start"
            },
        ]
    }

    const dataChartExpense: MultipleChartData = {
        labels: ["", ...valueExpense?.map((item) => item.location_name) || []],
        datasets: [
            {
                data: [0, ...valueExpense?.map((item) => item.balance) || []],
                backgroundColor: chartType === "line" ? ["rgba(255, 165, 0, 0.2)"] : ['rgb(167, 230, 255)'],
                borderColor: chartType === "line" ? ["rgb(255, 165, 0)"] : ['rgb(167, 230, 255)'],
                fill: "start"
            },
        ]
    }


    return (
        <section>
            <span className="font-bold text-[15px]">Profitablity</span>
            <div className="grid lg:grid-cols-3 mt-2 gap-4">
                <div className="flex-grow">
                    <Card className="flex-grow h-full">
                        <Card.Body>
                            <CardSection
                                label="Profit Or Lose"
                                value={valueProfitAndLose ? convertNumber(valueProfitAndLose)?.intoNormalAmount! : 0}
                            >
                                <div className="mt-[50px]">
                                    <MultipleChart
                                        chartType="bar"
                                        data={{
                                            labels: [`${moment(`${params.month}${params.year}`, "MMYYYY").format("MMMM YYYY")}`],
                                            datasets: [
                                                {
                                                    data: [valueProfitAndLose!],
                                                    backgroundColor: ['rgb(167, 230, 255)'],
                                                    borderColor: ['rgb(167, 230, 255)'],
                                                }
                                            ]
                                        }}
                                        className="h-[300px]"
                                    />
                                </div>
                            </CardSection>
                        </Card.Body>
                    </Card>
                </div>
                <div className="flex flex-col gap-2 lg:col-span-2">
                    <Card className="lg:h-[310px]">
                        <Card.Body>
                            <div className="flex justify-between mb-2">
                                <div>
                                    <div className="text-md text-slate-600 font-bold flex items-center gap-2">
                                        Income
                                    </div>
                                    <div className="text-2xl font-bold">{convertNumber(sumValueIncome).intoNormalAmount}</div>
                                </div>
                                <MultipleChart.Dropdown
                                    value={chartType}
                                    onChange={(type) => setChartType(type)}
                                />
                            </div>
                            <div className="mt-[60px] lg:mt-2">
                                <MultipleChart
                                    chartType={chartType}
                                    data={dataChartIncome}
                                    className="h-[200px]"
                                />
                            </div>
                        </Card.Body>
                    </Card>
                    <Card className="lg:h-[310px]">
                        <Card.Body>
                            <div className="flex justify-between mb-2">
                                <div>
                                    <div className="text-md text-slate-600 font-bold flex items-center gap-2">
                                        Expenses
                                    </div>
                                    <div className="text-2xl font-bold">{convertNumber(sumValueExpense).intoNormalAmount}</div>
                                </div>
                            </div>
                            <div className="mt-[60px] lg:mt-2">
                                <MultipleChart
                                    chartType={chartType}
                                    data={dataChartExpense}
                                    className="h-[200px]"
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </section>
    )
}